import { LimingEvent, RDLiming } from '@cibo/core'
import { Stack, Tooltip, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const LimingCellDisplay = ({ value }: { value: RDLiming }) => {
  const { t } = useTranslation('@cibo/landmanager/LimingEditor')
  if (value?.input?.events?.length) {
    return (
      <Tooltip
        title={
          <Stack spacing={1} padding={1}>
            {value.input.events.map(({ date, amount, unit }: LimingEvent, index: number) => (
              <Stack key={index}>
                <Typography variant="body1">{t('eventDate', { date: new Date(date) })}</Typography>
                <Typography variant="body2" sx={{ color: 'default' }}>
                  {amount} - {t(unit)}
                </Typography>
              </Stack>
            ))}
          </Stack>
        }
      >
        <Typography variant="body1">{t('events', { count: value.input.events.length })}</Typography>
      </Tooltip>
    )
  }
  return <Typography>{t('none')}</Typography>
}
